<template>
  <base-section background-style="light">
    <motion.div
        class="testimonials-header"
        :initial="{ opacity: 0, y: 30 }"
        :whileInView="{ opacity: 1, y: 0 }"
        :transition="{ duration: 0.6 }"
        :inViewOptions="{ once: true }"
    >
      <gradient-title text="Was Kunden sagen" tag="h2" />
      <p class="testimonials-subtitle">Feedback von langjährigen Partnern</p>
    </motion.div>

    <div class="testimonials-grid">
      <motion.div
          class="testimonial-card"
          :initial="{ opacity: 0, x: -50 }"
          :whileInView="{ opacity: 1, x: 0 }"
          :transition="{ delay: 0.2, duration: 0.7 }"
          :inViewOptions="{ once: true }"
      >
        <code-editor filename="testimonial_omergy.js" :total-lines="15">
          <div class="code-line"><span class="keyword">const</span> <span class="variable">testimonial</span> = {</div>
          <div class="code-line">  <span class="property">company</span>: <span class="string">"OMERGY GmbH"</span>,</div>
          <div class="code-line">  <span class="property">author</span>: <span class="string">"Alexander Ardissone"</span>,</div>
          <div class="code-line">  <span class="property">position</span>: <span class="string">"Head of Development"</span>,</div>
          <div class="code-line">  <span class="property">rating</span>: <span class="number">5</span>,</div>
          <div class="code-line">  <span class="property">message</span>: <span class="string">`Ariel war über fünf Jahre fest im Entwicklerteam</span></div>
          <div class="code-line">    <span class="string">und unterstützte uns danach als Freelancer. Er ist ein</span></div>
          <div class="code-line">    <span class="string">zuverlässiger Profi mit tiefen Kenntnissen in PHP/Laravel, </span></div>
          <div class="code-line">    <span class="string">Vue.js, Infrastruktur, Kubernetes und AWS. Er erfasst Themen</span></div>
          <div class="code-line">    <span class="string">schnell, denkt bei komplexen Aufgaben mit und liefert </span></div>
          <div class="code-line">    <span class="string">pragmatische, saubere Lösungen. Dabei arbeitet er</span></div>
          <div class="code-line">    <span class="string">eigenständig, gründlich und sehr effizient. Seine offene</span></div>
          <div class="code-line">    <span class="string">und zuvorkommende Art macht die Zusammenarbeit besonders</span></div>
          <div class="code-line">    <span class="string">angenehm. Wir freuen uns auf weitere Projekte mit ihm!`</span></div>
          <div class="code-line">};</div>
        </code-editor>
      </motion.div>

      <motion.div
          class="testimonial-card"
          :initial="{ opacity: 0, x: 50 }"
          :whileInView="{ opacity: 1, x: 0 }"
          :transition="{ delay: 0.4, duration: 0.7 }"
          :inViewOptions="{ once: true }"
      >
        <code-editor filename="testimonial_sopamo.js" :total-lines="10">
          <div class="code-line"><span class="keyword">const</span> <span class="variable">testimonial</span> = {</div>
          <div class="code-line">  <span class="property">company</span>: <span class="string">"Sopamo GmbH"</span>,</div>
          <div class="code-line">  <span class="property">author</span>: <span class="string">"David Paul Mohr"</span>,</div>
          <div class="code-line">  <span class="property">position</span>: <span class="string">"Geschäftsführer"</span>,</div>
          <div class="code-line">  <span class="property">rating</span>: <span class="number">5</span>,</div>
          <div class="code-line">  <span class="property">message</span>: <span class="string">`Ariel ist super engagiert und kennt sich top im</span></div>
          <div class="code-line">    <span class="string">Laravel und Vue.js Umfeld aus. Sehr zuverlässig und super</span></div>
          <div class="code-line">    <span class="string">Kommunikation. Ich würde sehr gerne wieder mit ihm zusammen</span></div>
          <div class="code-line">    <span class="string">arbeiten :)`</span></div>
          <div class="code-line">};</div>
        </code-editor>
      </motion.div>
    </div>
  </base-section>
</template>

<script lang="ts" setup>
import { motion } from "motion-v"
import BaseSection from "@/views/sections/BaseSection.vue"
import GradientTitle from "@/components/GradientTitle.vue"
import CodeEditor from "@/components/CodeEditor.vue"
</script>

<style scoped>
.testimonials-header {
  text-align: center;
  margin-bottom: 4rem;
}

.testimonials-subtitle {
  font-size: 1.2rem;
  color: #4a5568;
  max-width: 600px;
  margin: 0 auto;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 3rem;
  align-items: start;
}

.testimonial-card {
  display: flex;
  justify-content: center;
}

.code-line {
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  font-size: 12px;
  line-height: 20px;
  color: #e1e4e8;
  white-space: nowrap;
}

.keyword {
  color: #ff7b72;
  font-weight: 600;
}

.variable {
  color: #79c0ff;
}

.property {
  color: #79c0ff;
}

.string {
  color: #a5d6ff;
}

.number {
  color: #79c0ff;
}

@media (max-width: 768px) {
  .testimonials-subtitle {
    font-size: 1rem;
  }

  .testimonials-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .code-line {
    font-size: 11px;
  }
}
</style>
